import registoryMutations from "./mutations.js";
import registoryActions from "./actions.js";
import registoryGetters from "./getters.js";

export default {
    namespaced: true,
    state() {
        return {
            overFlowMenu: [],
            quickAccessPanel: [],
            settingsSideMenu: [],
            floatingMenu: [],
            binsContextMenu: [],
            binsMoreContextMenu: [],
            binsNewContextMenu: [],
            binsImportContextMenu: [],
            binsShareContextMenu:[],
            catalogIconContextMenu:[],
            exportContextMenu:[],
            binsAIToolsContextMenu:[],
            binsOpenWithContextMenu:[],
            pluginMapper: {},
            importExportMenu: [],
            preferencesSidemenu: [],
            systemSettingsMenu: [],
            propertiesTopNav: [],
            dialogForMediaBrowse: [],
            shareTopNavMenu: [],
            reportsSideMenu: [],
            dashboardWidgets:[],
            appCss:{userDefinedCss:'',pluginChunkCss:''},
            quickAccesPanelSortedArr: [],
            lazyLoadPluginInfo:{},
            damComponentOnDemand:{},
            externalGlobalNewButtonPlugins:[],
            createReviewButtons:[],
            metadataPluginExpandCollapseList:[],
            metadataDockPluginsList:[],
            licenseInfoDetails:[],
            subclipPluginsList:[],
            propertiesTabsPlugins:[],
            pamBrowsePluginsList:[],
            dashboardWidgetPlugin:[],
            connectedApps:[],
            reviewTagsArr:[],
            myApps:[],
            linksBrowsePluginsList:[],
            customReportsSelectionField:[],
            registeredPluginRoutesForLoadingMapper:{},
            dontPlayMiniplayerInTheBackround_openedScreens:["asset-metadata-manager","metadata-manager","sub-clips-manager","bin-sub-clips-manager","asset-PartialRetrieve","PartialRetrieve","file-facedetection","asset-facedetection","asset-video-transcript","VideoTranscript","asset-object-detection","file-object-detection"]
        };
    },
    mutations: registoryMutations,
    actions: registoryActions,
    getters: registoryGetters,
};